"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_multi_date_picker_1 = __importDefault(require("react-multi-date-picker"));
var date_panel_1 = __importDefault(require("react-multi-date-picker/plugins/date_panel"));
require("./DateRangePicker.css");
var ThemeContext_1 = require("../theme-context/ThemeContext");
var DataRangePicker = function (_a) {
    var selectedRanges = _a.selectedRanges, setSelectedRanges = _a.setSelectedRanges, selectRandom = _a.selectRandom, _b = _a.format, format = _b === void 0 ? "MM/DD/YYYY" : _b, style = _a.style;
    var _c = (0, ThemeContext_1.useTheme)(), themeMode = _c.themeMode, currentTheme = _c.currentTheme;
    var minDate = (0, react_1.useState)(new Date())[0];
    var containerRef = (0, react_1.useRef)(null);
    var handleDateSelection = function (selectedDates) {
        if (Array.isArray(selectedDates)) {
            setSelectedRanges(selectedDates);
        }
        else if (selectedDates) {
            setSelectedRanges([selectedDates]);
        }
        else {
            setSelectedRanges([]);
        }
    };
    (0, react_1.useEffect)(function () {
        document.documentElement.classList.toggle("dark-mode", themeMode === "dark");
    }, [themeMode]);
    // Clear selections when selectRandom changes
    (0, react_1.useEffect)(function () {
        setSelectedRanges([]);
    }, [selectRandom, setSelectedRanges]);
    var weekDaysShort = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
    return (react_1.default.createElement("div", { className: "".concat(themeMode, "-date-picker"), ref: containerRef },
        react_1.default.createElement("div", { className: "date-picker-container", style: {
                background: currentTheme.callAutomationPage.dateBackground,
            } },
            react_1.default.createElement("img", { className: "calendar-icon", src: themeMode === "dark"
                    ? "/icons/calendar-dark.svg"
                    : "/icons/calendar.svg", alt: "Calendar" }),
            react_1.default.createElement(react_multi_date_picker_1.default, { className: "".concat(themeMode, "-ca-date-picker"), inputClass: "date-picker-input", containerClassName: "date-picker-popup-container", value: selectedRanges, placeholder: "Select Dates", onChange: handleDateSelection, multiple: !selectRandom, range: !selectRandom, style: __assign(__assign({}, style), { width: '100%' }), sort: true, format: format, calendarPosition: "bottom-left", plugins: [
                    react_1.default.createElement(date_panel_1.default, { position: "bottom", markFocused: true, className: "table-scroll-container" }),
                ], minDate: minDate, weekDays: weekDaysShort }))));
};
exports.default = DataRangePicker;
